import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {MediaObserver} from '@angular/flex-layout';
import {CookieService} from 'ngx-cookie-service';
import {interval, Subject} from 'rxjs';
import {BaseService} from '../../../app/services/base.service';
import {AuthService} from '../../../app/services/auth.service';
import {NotificationMinute} from '../../../app/dto/notification-minute';
import {MatDialog} from '@angular/material';
import {CustomDialogComponent} from '../custom-dialog/custom-dialog.component';
import {RxStompService} from '@stomp/ng2-stompjs';
import {Message} from '@stomp/stompjs';
import {FuseMatchMediaService} from '../../services/match-media.service';
import {FuseNavigationService} from '../navigation/navigation.service';
import {User} from '../../../app/dto/user';

@Component({
    selector: 'fuse-shortcuts',
    templateUrl: './shortcuts.component.html',
    styleUrls: ['./shortcuts.component.scss']
})
export class FuseShortcutsComponent implements OnInit, AfterViewInit, OnDestroy {
    shortcutItems: any[];
    navigationItems: any[];
    filteredNavigationItems: any[];
    searching: boolean;
    mobileShortcutsPanelActive: boolean;
    notifications: NotificationMinute[] = [];
    badgeno = 0;
    @Input()
    navigation: any;

    @ViewChild('searchInput', {static: false})
    searchInputField;

    @ViewChild('shortcuts', {static: false})
    shortcutsEl: ElementRef;
    loggedUser: User;
    // Private
    private _unsubscribeAll: Subject<any>;
    filters = {
        'Seen': null,
        'PageNumber': 0,
        'RecordsPerPage': 20
    };


    /**
     * Constructor
     *
     * @param {CookieService} _cookieService
     * @param {FuseMatchMediaService} _fuseMatchMediaService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {MediaObserver} _mediaObserver
     * @param {Renderer2} _renderer
     * @param service
     * @param auth
     * @param matDialog
     * @param rxStompService
     */
    constructor(
        private _cookieService: CookieService,
        private _fuseMatchMediaService: FuseMatchMediaService,
        private _fuseNavigationService: FuseNavigationService,
        private _mediaObserver: MediaObserver,
        private _renderer: Renderer2,
        private service: BaseService,
        private auth: AuthService,
        private matDialog: MatDialog,
        private rxStompService: RxStompService
    ) {
        this.loggedUser = this.auth.user;
        // Set the defaults
        this.shortcutItems = [];
        this.searching = false;
        this.mobileShortcutsPanelActive = false;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        // this.loggedUser = this.auth.user;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        let topic = null;
        if (this.loggedUser) {
            topic = '/topic/' + this.loggedUser.Id.toString() + '/notification';
        }


        this.rxStompService.watch(topic).subscribe((message: Message) => {
            this.notifications = JSON.parse(message.body)['content'];
            this.badgeno = 0;
            this.notifications.forEach(data => {
                console.log('>>>>---->>>> ' + data.Message + ' ' + data.CreatedAt);
                if (!data.Seen) {
                    this.badgeno++;
                }

            });
        });

        // this.rxStompService.publish({destination: 'pharmaws/start'});

        this.load();
        interval(60000).subscribe(x => {
            // this.load();

        });

        // Get the navigation items and flatten them
        this.filteredNavigationItems = this.navigationItems = this._fuseNavigationService.getFlatNavigation(this.navigation);

        // if ( this._cookieService.check('FUSE2.shortcuts') )
        // {
        //     this.shortcutItems = JSON.parse(this._cookieService.get('FUSE2.shortcuts'));
        // }
        // else
        // {
        //     // User's shortcut items
        //     this.shortcutItems = [
        //
        //
        //     ];
        // }

    }

    // tslint:disable-next-line:typedef
    openDialog(data: NotificationMinute) {
        if (!data.Seen) {
            this.notifications.forEach(noti => {

                // tslint:disable-next-line:triple-equals
                if (noti.Id == data.Id) {
                    noti.Seen = true;
                }

            });
        }
        this.matDialog.open(CustomDialogComponent, {
            data: data
        });
    }

    ngAfterViewInit(): void {
        // Subscribe to media changes
        // this._fuseMatchMediaService.onMediaChange
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe(() => {
        //         if ( this._mediaObserver.isActive('gt-sm') )
        //         {
        //             this.hideMobileShortcutsPanel();
        //         }
        //     });
    }

    // tslint:disable-next-line:typedef
    load() {

        this.service.getNotificationList({
            Seen: this.filters.Seen, PageNumber: this.filters.PageNumber,
            RecordsPerPage: this.filters.RecordsPerPage
        }).subscribe(pTourtypes => {
            this.notifications = pTourtypes;
            this.badgeno = 0;
            this.notifications.forEach(data => {

                if (!data.Seen) {
                    this.badgeno++;
                }

            });
        });


    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Search
     *
     * @param event
     */
    // search(event): void
    // {
    //     const value = event.target.value.toLowerCase();
    //
    //     if ( value === '' )
    //     {
    //         this.searching = false;
    //         this.filteredNavigationItems = this.navigationItems;
    //
    //         return;
    //     }
    //
    //     this.searching = true;
    //
    //     this.filteredNavigationItems = this.navigationItems.filter((navigationItem) => {
    //         return navigationItem.title.toLowerCase().includes(value);
    //     });
    // }

    /**
     * Toggle shortcut
     *
     * @param event
     * @param itemToToggle
     */
    // toggleShortcut(event, itemToToggle): void
    // {
    //     event.stopPropagation();
    //
    //     for ( let i = 0; i < this.shortcutItems.length; i++ )
    //     {
    //         if ( this.shortcutItems[i].url === itemToToggle.url )
    //         {
    //             this.shortcutItems.splice(i, 1);
    //
    //             // Save to the cookies
    //             this._cookieService.set('FUSE2.shortcuts', JSON.stringify(this.shortcutItems));
    //
    //             return;
    //         }
    //     }
    //
    //     this.shortcutItems.push(itemToToggle);
    //
    //     // Save to the cookies
    //     this._cookieService.set('FUSE2.shortcuts', JSON.stringify(this.shortcutItems));
    // }

    /**
     * Is in shortcuts?
     *
     * @param navigationItem
     * @returns {any}
     */
    // isInShortcuts(navigationItem): any
    // {
    //     return this.shortcutItems.find(item => {
    //         return item.url === navigationItem.url;
    //     });
    // }

    /**
     * On menu open
     */
    // onMenuOpen(): void
    // {
    //     setTimeout(() => {
    //         this.searchInputField.nativeElement.focus();
    //     });
    // }

    /**
     * Show mobile shortcuts
     */
    // showMobileShortcutsPanel(): void
    // {
    //     this.mobileShortcutsPanelActive = true;
    //     this._renderer.addClass(this.shortcutsEl.nativeElement, 'show-mobile-panel');
    // }

    /**
     * Hide mobile shortcuts
     */
    // hideMobileShortcutsPanel(): void
    // {
    //     this.mobileShortcutsPanelActive = false;
    //     this._renderer.removeClass(this.shortcutsEl.nativeElement, 'show-mobile-panel');
    // }
}
